import React from "react";
import Css from "../React/FrameReact.module.css";
import { Link } from "react-router-dom";
import FrameWorkImage from "../PackageImage/FrameWorkImage";
const FullStack = () => {
  const products = [
    {
      id: 1,
      title: "Instagram",
      FrameWork: "React & Node Js",
      paragraph: "Simple idea project but contains a lot of information like connecting with API & The Project",
      span: "Responsive",
      Preview: "https://chat97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Instagram",
      image: FrameWorkImage.instagram,
    },
    {
      id: 1,
      title: "Bistro-Bliss",
      FrameWork: "React & Node Js",
      paragraph: "First Project using FullStack",
      span: "Responsive",
      Preview: "https://bistro-bliss97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/BistroBliss-FullStack",
      image: FrameWorkImage.BistroBliss,
    },
    
  ];
  return (
    <div>
      <div className={Css.container}>
        {products?.map((r) => (
          <div className={Css.cards} key={r.id}>
            <div className={Css.card}>
              <div className={Css.img}>
                <Link to={r.Preview} target="_blank">
                  <img src={r.image} alt="" />
                </Link>
              </div>
              <div className={Css.text}>
                <h2>
                  {r.title} <span>{r.FrameWork}</span>
                </h2>
                <p>
                  {r.paragraph} <span>{r.span}</span>
                </p>
                <div className={Css.src}>
                  <Link target="_blank" to={r.Preview}>
                    Preview
                  </Link>
                  <Link target="_blank" to={r.GitHub}>
                    GitHub
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FullStack;
